// Central map: backend `error.code` → user-facing copy.
//
// Backend (commit 432a0fe) emits the codes below — kept in sync with
// `backend/app/services/csv_validation.py` and `backend/app/api/v1/*`.
// Unknown codes fall through to the raw `message` from the envelope so
// new backend codes never silently render as empty strings.

export const ERROR_MESSAGES: Record<string, string> = {
  // Datasets — upload
  'dataset.too_large': 'File must be 5MB or smaller.',
  'dataset.unsupported_mime': 'Only CSV files are supported.',
  'dataset.empty': 'The uploaded file is empty.',
  'dataset.unparseable': "We couldn't parse this file as CSV.",
  'dataset.unreadable': 'The file is not UTF-8 encoded.',
  'dataset.compressed_upload_not_supported':
    'Please upload an uncompressed .csv file (no .gz / .zip / .bz2).',
  'dataset.too_many_rows': 'Maximum 100,000 rows supported.',
  'dataset.too_few_rows': 'CSV must have at least one data row.',
  'dataset.too_many_cols': 'Maximum 200 columns supported.',
  'dataset.too_few_cols': 'CSV must have at least 2 columns.',
  'dataset.duplicate_column_names': 'Column names must be unique.',
  'dataset.invalid_column_name':
    'Column names must start with a letter or underscore and contain only A-Z, 0-9, ., _, -.',
  'dataset.non_numeric_column': 'All columns must contain numeric values.',
  'dataset.validation_failed': 'CSV failed validation.',
  // Datasets — lifecycle
  'dataset.not_found': 'Dataset not found.',
  'dataset.has_active_jobs': 'Cannot delete: dataset has running or queued discoveries.',
  // Discoveries
  'discovery.not_found': 'Discovery not found.',
  'discovery.not_cancelable': 'This discovery has already finished and cannot be canceled.',
  'discovery.sync_timeout':
    'The discovery is taking longer than expected — it was queued to finish in the background.',
  'discovery.not_supported_in_iter_5': 'That option is not supported yet.',
  // Knowledge
  'knowledge.not_found': 'Knowledge object not found.',
  'knowledge.empty_payload':
    'Add at least one forbidden edge, required edge, or tier before saving.',
  'knowledge.no_changes': 'Nothing to update — change the name or payload first.',
  'knowledge.dataset_mismatch':
    'This knowledge is pinned to a different dataset — pick org-wide knowledge instead.',
  // Quota
  'quota.exceeded':
    "You've used all your discoveries for this period — upgrade your plan or wait for reset.",
  // Generic
  'pagination.invalid_cursor': 'Invalid pagination cursor.',
  'request.validation_failed': 'The request was invalid.',
  idempotency_key_param_mismatch:
    'A previous request with the same Idempotency-Key used different parameters.',
  'auth.token_expired': 'Your session expired — please sign in again.',
  'auth.token_invalid': 'Your session is invalid — please sign in again.',
};

export function friendlyError(code: string | undefined, fallback: string): string {
  if (!code) return fallback;
  return ERROR_MESSAGES[code] ?? fallback;
}
